import React from "react";
import { Route } from "react-router-dom";
import ConferenceLayout from "../layouts/conference/index";
const ConferenceRoute = ({ children }) => {
    return <ConferenceLayout>{children}</ConferenceLayout>;
};

export default ConferenceRoute;
